import { useQueryClient, useMutation } from '@tanstack/react-query';
import { getCloudEntriesQueryKey } from './query.get-cloud-entries.js';
import { saveCloudEntry } from './request.save-cloud-entry.js';

function useSaveCloudEntryMutation(componentEntryId) {
  const client = useQueryClient();
  return useMutation(SaveCloudEntryMutation(client, componentEntryId));
}
const SaveCloudEntryMutation = (client, componentEntryId) => {
  return {
    mutationKey: ["component-framework/save-cloud-entry", componentEntryId],
    mutationFn: cloudEntry => saveCloudEntry(componentEntryId, cloudEntry),
    onMutate: async input => {
      const prevEntries = client.getQueryData(getCloudEntriesQueryKey(componentEntryId));
      client.setQueryData(getCloudEntriesQueryKey(componentEntryId), previous => ({
        ...previous,
        ...input
      }));
      await client.cancelQueries({
        queryKey: getCloudEntriesQueryKey(componentEntryId)
      });
      return {
        prevEntries
      };
    },
    onError: (error, _, context) => {
      client.setQueryData(getCloudEntriesQueryKey(componentEntryId), previous => ({
        ...previous,
        ...context?.prevEntries
      }));
    }
  };
};

export { useSaveCloudEntryMutation };
//# sourceMappingURL=mutation.save-cloud-entry.js.map
